import { message } from "antd";
import config from "../../../config.json";
import {
  patchRequest,
  postRequest,
  formatRequestError,
} from "../../../utils/requests";

const isNotFinished = (app) => {
  return (app.status === "ORDER_DELIVERED" && app.isHasMontage === true)
}

export const fetchStatuses = (
  state = "NEW",
  status = "",
  query = "",
  setSpecifications = () => { },
  setIsLoading = () => { },
  setTotalPage = () => { }, // Добавляем эту функцию в параметры
  size = 20,
  page = 1,
  remaining = false,
  excludeStatus = ""
) => {
  let url = `${config.service}/api/appl/state?search=${query}&page=${page}&size=${size}`;

  const body = { state };
  if (status) {
    body.status = status;
  }
  if (excludeStatus) {
    body.excludeStatus = excludeStatus;
  }

  const response = postRequest(url, body, {});

  response
    .then((data) => {
      if (remaining) {
        const filtered = data.data.application.filter(app => isNotFinished(app) || app.status === "ORDER_INSTALLED");
        setSpecifications(filtered);
        return;
      }
      setSpecifications(data.data.application);
      setTotalPage(data.data.totalCount); // Теперь setTotalPage определён
    })
    .finally(() => {
      setIsLoading(false);
    });

  return response;
};

export const acceptApplication = (id, onFinish) => {
  const url = `${config.service}/api/appl/changeState/${id}`;
  const body = {
    state: "ACTIVE",
    status: "ASSEMBLING_CARCASS",
  };

  const response = patchRequest(url, body);

  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Готово", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();

      if (onFinish) {
        onFinish();
      }
    });
};

export const refuseApplication = (id, onFinish) => {
  const url = `${config.service}/api/appl/changeState/${id}`;
  const body = {
    state: "NEW",
    status: "REFUSED",
  };

  const response = patchRequest(url, body);

  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Готово", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();

      if (onFinish) {
        onFinish();
      }
    });
};

export const updateApplication = (id, body, onFinish) => {
  const url = `${config.service}/api/appl/changeStatus/${id}`;

  const response = patchRequest(url, body);

  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Обновлено", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();

      if (onFinish) {
        onFinish();
      }
    });
};

export const updateApplicationStatus = (id, body, onFinish) => {
  const url = `${config.service}/api/appl/changeStatus/${id}`;

  const response = patchRequest(url, body);

  const hideLoadingMsg = message.loading("Загрузка...", 0);
  response
    .then(() => {
      message.success("Обновлено", 3);

      if (onFinish) {
        onFinish();
      }
    })
    .catch((err) => {
      message.error(formatRequestError("Ошибка", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};
